import gql from 'graphql-tag';

export const CREATE_SSO_PLACEHOLDER_CONNECTION = gql`
  mutation createSsoPlaceholderConnection($groupId: String!) {
    createSsoPlaceholderConnection(groupId: $groupId) {
      connectionId
      entityId
      acsUrl
      ssoLoginUrl
      signInUrl
      hasPlaceholderCert
    }
  }
`;
